import {subscribeExt} from "../modules/subscribe";

export function articleDetailPage() {

    function showViewport() {
        var selector    = document.querySelector('.article-description');
        var height      = Math.max(selector.clientHeight, window.innerHeight || 0);
        $('.side-overlay').css({'height': height+'px'});

        var $window = $(window);
        var $sidebar = $("#articles-detail-sidebar");
        var $sibling_block_height = $('.article-description');
        var $sidebarHeight = $sidebar.innerHeight();


        if($sidebarHeight < $sibling_block_height.innerHeight() - 200) {

            var $footerOffsetTop = $(".subscribe-wrp").offset().top - 50;
            var $sidebarOffset = $sidebar.offset();

            $window.scroll(function () {

                if ($window.scrollTop() > $sidebarOffset.top) {
                    $sidebar.addClass("fixed").addClass("sticky");
                } else {
                    $sidebar.removeClass("sticky");
                    $sidebar.removeClass("fixed");
                }

                if ($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
                    $sidebar.removeClass("sticky");
                    $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
                } else {
                    $sidebar.css({"top": "0"});
                }
            });
        }
    }

    function actions() {
        if($('.article-detail').length > 0) {
            subscribeExt(3800);
            $('.prettySocial').prettySocial();
            window.onload = showViewport;
            window.onresize = showViewport;
        }
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/pages/article_detail.js